import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { SearchService } from 'shared/search/search.service';
import { SearchModel } from 'shared/search/search.model';
import { Config } from 'shared/config/env.config';

@Injectable()
export class DashboardSearchService extends SearchService {

  getSearchURI(brandId: string, searchModel: SearchModel): string {
    let searchUri: string;
    const type = searchModel.route;
    if (type === 'working') {             searchUri = `/items/${brandId}/working`; } // my-products
    if (type === 'published') {           searchUri = `/items/${brandId}/published`; } // my-products
    if (type === 'my' || type === 'library') { // receivers
      searchUri = `/receivers/${brandId}`;
    }
    return searchUri;
  }

  getQueryString(searchModel: SearchModel): string {
    return `${super.getQueryString(searchModel)}&totalOnly=1`;
  }

  /* eslint-disable */
  handleSearchRes() {}
  /* eslint-enable */

}
